var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDevicescontactSensorfront = function SvgDevicescontactSensorfront(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "50px",
    viewBox: "0 0 30 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "devices/devices.contact_sensor.front") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "devices/devices.contact_sensor.front",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.000000, 20.000000) rotate(-180.000000) translate(-15.000000, -20.000000) translate(0.000000, 5.000000)",
    stroke: "#666666"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 3.5,
    x2: 21,
    y2: 3.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 22.000000)",
    strokeLinecap: "square",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 5,
    x2: 6,
    y2: 5,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 3,
    x2: 6,
    y2: 3,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 1,
    x2: 6,
    y2: 1,
    id: "Line"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#666666",
    fill: "#FFFFFF",
    x: 0.5,
    y: 39.5,
    width: 29,
    height: 5
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDevicescontactSensorfront);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/devices.contact_sensor.front.ac233c3680d2ff8f54b3186357b04753.svg";